import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitch } from 'primeng/toggleswitch';

@Component({
  selector: 'app-custom-toggle-switch',
  templateUrl: './custom-toggle-switch.component.html',
  styleUrls: ['./custom-toggle-switch.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ToggleSwitch],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomToggleSwitchComponent),
      multi: true
    }
  ]
})
export class CustomToggleSwitchComponent implements ControlValueAccessor {

  onChange: (value: boolean) => void = () => { };
  onTouched: () => void = () => { };
  value: boolean = false;

  @Input() disabled: boolean = false; // ✅ AQUÍ
  @Input() labelText: string = "";
  @Input() checked: boolean = false;
  @Output() onChangeToggle = new EventEmitter<boolean>();

  ngOnInit() {
    if (this.checked !== undefined) {
      this.value = this.checked;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['checked'] && !changes['checked'].firstChange) {
      this.value = changes['checked'].currentValue;
      this.onChange(this.value);
    }
  }

  changeToggle(value: boolean | null) {
    this.value = value ?? false;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeToggle.emit(this.value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: boolean): void {
    this.value = !!value;
  }
}
